/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action, set } from '@ember/object';
import DeviceAttributeCondition from 'cio/app-models/conditions/device-attribute';
import { isNone } from '@ember/utils';

interface NameArgs {
  attributeNames: { value: string; label: string }[];
  condition: DeviceAttributeCondition;
  disabled: boolean;
  onInput: (name: string) => unknown;
}
export default class Name extends Component<NameArgs> {
  @action
  onChange(selection: Record<string, string> | null) {
    if (!isNone(selection)) {
      this.args.onInput(selection.value);
    }
    return set(this.args.condition, 'name', selection?.value ?? '');
  }
}
